/* eslint-disable @typescript-eslint/naming-convention */
export class RegistrationVariables {
	public static readonly LOCAL_CREDENTIALS_SALT = 'd+HuQl:EC@_=';
}
